export enum Kind {
  CONTENT = 'Content',
  SYSTEM_ROLE = 'SystemRole',
  SEAMLESS = 'Seamless',
  INFRASTRUCTURE = 'Infrastructure',
  ACADEMY = 'Academy',
  REPOSITORY = 'Repository',
  GITHUB_ACTION = 'GitHubAction',
  TOOL = 'Tool',
}
